import { Controller } from '@hotwired/stimulus'
import Sortable from 'sortablejs'
import { put } from '@rails/request.js'

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      handle: '[data-sortable-handle]',
      onEnd: () => this.save()
    })
  }

  disconnect() {
    this.sortable.destroy()
  }

  async save() {
    const ids = [...this.element.children].map((child) => child.dataset.id).filter(Boolean)
    await put(this.urlValue, { body: { ids } })
  }
}
